import Axios from '../utils/axios-utils';

// create Services
export const createServices = async (data, accountId) => {
    try {
        const response = await Axios.post(`/accounts/${accountId}/services`, {
            vehicleId: data.vehicleId,
            vendorId: data.vendorId,
            types: data.types,
            serviceTime: data.serviceTime,
            odometer: data.odometer,
            amount: data.amount,
            note: data.note
        });

        return { success: response.data.status === 'success', data: response.data };
    } catch (error) {
        console.log("Create Services error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Create Services failed" }
        };
    }
};

// get all services
export const getAllServices = async (accountId, from, to) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/services`, {
            params: { from, to },
        });

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Services error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Services failed" }
        };
    }
};

// get all service types
export const getAllServiceRTypes = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/services/types`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Service types error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Service types failed" }
        };
    }
};

// delete services
export const deleteServices = async (accountId, serviceId) => {
    try {
        const response = await Axios.delete(`/accounts/${accountId}/services/${serviceId}`);

        return {
            success: response.data.status === 'success',
            data: response.data,
            status: response.status
        };
    } catch (error) {
        console.log("Delete Services error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Delete Services failed" },
            status: error.response?.status || 500
        };
    }
};

// update Service
export const updateService = async (accountId, serviceId, data) => {
    try {
        const response = await Axios.patch(`/accounts/${accountId}/services/${serviceId}`, data);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Update Services error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Update Services failed" }
        };
    }
};

// update services status
export const updateServicesStatus = async (accountId, serviceId, status) => {
    try {
        const response = await Axios.patch(`/accounts/${accountId}/services/${serviceId}/status`, {
            status,
        });

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Update Service Status error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Update Service Status failed" }
        };
    }
};

// get all Service statuses
export const getAllServiceStatuses = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/services/statuses`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Service statuses error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Service statuses failed" }
        };
    }
};


// get  services media
export const getServicesMedia = async (accountId, serviceId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/services/${serviceId}/media`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get Services media error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get Services media failed" }
        };
    }
};